import React, { useState } from "react";
import { INews } from "../../../adminPage";
import { baseUrl } from "../../../../../constants/constants";
import tags from "../../../../public/test_page/tags/tags";

interface INewsArchive {
  news: INews;
  updateStatusNews: (cuurentNews: INews) => void;
}

const NewsArchive: React.FC<INewsArchive> = ({ news, updateStatusNews }) => {
    const date = new Date(news.create_date).toLocaleString('ru', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

    const selectedTags = news.tags
        .map((tag) => tag.name)
        .join(', ') || 'Тегов нет'

    return (
    <tr>
        <td className="applications-table__tbody-td">
            <img
                src={`${baseUrl}${news.image_url}`}
                alt='Картинка новости'
                className="cards-settings__img"
            />
        </td>
        <td className="applications-table__tbody-td">{news.name}</td>
        <td className="applications-table__tbody-td">{news.description}</td>
        <td className="applications-table__tbody-td">{date}</td>
        <td className="applications-table__tbody-td_tags">{selectedTags}</td>
        <td className="applications-table__tbody-td_actions">
            <button
                className="button updateBtn"
                onClick={() => updateStatusNews(news)}
            >
                Вернуть
            </button>
        </td>
    </tr>
  );
};

export default NewsArchive;
